import Gallery from "./Gallery.svelte";
import { Node } from "@tiptap/core";
import { SvelteNodeViewRenderer } from "svelte-tiptap";
import { SvelteSSRRenderer } from "$components/editor/utils";
import { v4 as uuidv4 } from "uuid";
import { docURL } from "app/utils/urls";
import { communitySlug } from "app/stores/community";
import { slugify } from "app/utils/strings";
import { get } from "svelte/store";
import { type MarkdownSerializerState } from "prosemirror-markdown";
import { type Node as PMNode } from "@tiptap/pm/model";

export interface Item {
  cellUUID: string;
  uuid: string;
  title: string;
  type: "doc" | "folder";
  icon: string | undefined;
  iconDark: string | undefined;
  description: string;
  count?: number;
}

export interface ItemsRow {
  uuid: number;
  items: Item[];
}

export default Node.create({
  name: "docsGallery",
  group: "block",
  draggable: true,
  atom: true,
  selectable: false,

  addAttributes() {
    return {
      rows: { default: [{ uuid: uuidv4(), items: [] }] },
    };
  },

  parseHTML() {
    return [
      {
        tag: "docs-gallery",
      },
    ];
  },

  renderHTML({ node, HTMLAttributes }) {
    return SvelteSSRRenderer("docs-gallery", Gallery, { node, attributes: HTMLAttributes });
  },

  addNodeView() {
    return SvelteNodeViewRenderer(Gallery);
  },

  addStorage() {
    return {
      markdown: {
        serialize: (state: MarkdownSerializerState, node: PMNode) => {
          const rows = node.attrs.rows;

          rows.forEach((row: ItemsRow) => {
            row.items.forEach((item: Item) => {
              const url = docURL({
                communitySlug: get(communitySlug),
                docUuid: item.uuid,
                docSlug: slugify(item.title),
              });
              state.write(`- [${item.title}](${url})\n`);
              if (item.description) {
                state.write(`  - ${item.description}\n`);
              }
            });
          });

          state.write("\n");

          // Example of final format:
          // - [Document Title 1](https://example.com/community/doc-1)
          //   - Description of document 1
          // - [Document Title 2](https://example.com/community/doc-2)
          //   - Description of document 2
        },
      },
    };
  },
});
